import { Component, OnInit, Input, Renderer2, ElementRef } from '@angular/core';

@Component({
  selector: 'app-content-loader',
  templateUrl: './content-loader.component.html',
  styleUrls: ['./content-loader.component.css'],
})
export class ContentLoaderComponent implements OnInit {
  @Input() loading: boolean;
  @Input() padding = '7';
  @Input() size = 'lg';

  constructor(private renderer: Renderer2, private ref: ElementRef) {}

  ngOnInit() {
    this.renderer.addClass(this.ref.nativeElement, 'no-hover');
  }
}
